// eslint-disable-next-line import/no-unresolved
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';
// import 'photoswipe/dist/photoswipe.css';
// import CustomUI from './button';

/**
 * @class
 * @param {String} gallery
 * @param {String} children
 */
export default function PhotoSwipeGallery(gallery, children) {
  const backEasing = {
    in: 'cubic-bezier(0.6, -0.28, 0.7, 1)',
    out: 'cubic-bezier(0.3, 0, 0.32, 1.275)',
    inOut: 'cubic-bezier(0.68, -0.55, 0.265, 1.55)',
  };

  const lightbox = new PhotoSwipeLightbox({
    gallery,
    children,
    pswpModule: () => PhotoSwipe,
    showHideAnimationType: 'zoom',
    showAnimationDuration: 700,
    hideAnimationDuration: 700,
    preload: [1, 4],
    errorMsg: 'Ошибка. Фото не может быть загружено',
  });

  lightbox.on('firstUpdate', () => {
    lightbox.pswp.options.easing = backEasing.out;
  });
  lightbox.on('initialZoomInEnd', () => {
    lightbox.pswp.options.easing = backEasing.inOut;
  });
  lightbox.on('close', () => {
    lightbox.pswp.options.easing = backEasing.in;
  });
  lightbox.on('tapAction', (e) => {
    if (e.originalEvent.target.classList.contains('pswp__item')) {
      lightbox.pswp.close();
    }
  });
  lightbox.on('change', () => {
    // movie block asset
    lightbox.pswp.container
      ?.querySelector('iframe')
      ?.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
    // triggers when slide is switched, and at initialization
    window.location.hash = `slide-${lightbox.pswp.currIndex}`;
  });

  lightbox.addFilter('itemData', (itemData) => {
    const movieFrame = itemData.element.dataset.movie;
    if (movieFrame) {
      itemData.googleMapUrl = movieFrame;
    }
    return itemData;
  });
  lightbox.on('contentLoad', (e) => {
    const { content } = e;

    if (content.data.element.dataset.video) {
      e.preventDefault();
      content.element = document.createElement('div');
      content.element.className = 'pswp__video-container';
      content.element.innerHTML = content.data.element.dataset.video;
    }
  });
  lightbox.init();
}
